import React from 'react';
import { Button } from './ui/Button';
import { Check, FileText, Smartphone, Shield } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function OfferSection() {
  return <section id="pricing" className="py-14 bg-slate-50" data-id="element-125">
      <div className="container mx-auto px-4" data-id="element-126">
        <div className="max-w-4xl mx-auto" data-id="element-127">
          {/* Main Offer Card */}
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-slate-200" data-id="element-128">
            <div className="grid md:grid-cols-2" data-id="element-129">
              {/* Left: What's Included */}
              <div className="p-6 md:p-10" data-id="element-130">
                <h3 className="text-2xl font-bold text-slate-900 mb-5" data-id="element-131">
                  Qué incluye el sistema:
                </h3>

                <div className="space-y-5" data-id="element-132">
                  <div className="flex gap-4" data-id="element-133">
                    <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-134">
                      <FileText className="w-5 h-5 text-blue-600" data-id="element-135" />
                    </div>
                    <div data-id="element-136">
                      <h4 className="font-semibold text-slate-900" data-id="element-137">
                        PDF "Cero Pánico de Deudas"
                      </h4>
                      <p className="text-sm text-slate-600" data-id="element-138">
                        Tu plan de acción día por día.
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4" data-id="element-139">
                    <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-140">
                      <Shield className="w-5 h-5 text-green-600" data-id="element-141" />
                    </div>
                    <div data-id="element-142">
                      <h4 className="font-semibold text-slate-900" data-id="element-143">
                        Plantillas Google Sheets
                      </h4>
                      <p className="text-sm text-slate-600" data-id="element-144">
                        Mapa de Deudas, Ranking, Presupuesto y PMV.
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4" data-id="element-145">
                    <div className="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center" data-id="element-146">
                      <Smartphone className="w-5 h-5 text-purple-600" data-id="element-147" />
                    </div>
                    <div data-id="element-148">
                      <h4 className="font-semibold text-slate-900" data-id="element-149">
                        Pack de Scripts (Guiones)
                      </h4>
                      <p className="text-sm text-slate-600" data-id="element-150">
                        Qué decir exactamente por WhatsApp y teléfono.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right: Pricing & CTA */}
              <div className="bg-slate-900 p-6 md:p-10 flex flex-col justify-center text-center relative overflow-hidden" data-id="element-151">
                {/* Decorative circles */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-152"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-blue-500/10 rounded-full translate-y-1/2 -translate-x-1/2" data-id="element-153"></div>

                <p className="text-slate-400 text-sm uppercase tracking-widest mb-2" data-id="element-154">
                  Pago Único
                </p>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-155">
                  <span className="text-xl text-slate-500 line-through decoration-slate-500/50" data-id="element-156">
                    $39.900
                  </span>
                  <div className="text-5xl font-bold text-white" data-id="element-157">
                    $19.900{' '}
                    <span className="text-2xl text-slate-400 font-normal" data-id="element-158">
                      COP
                    </span>
                  </div>
                </div>
                <p className="text-slate-300 text-sm mb-6" data-id="element-159">
                  Menos de lo que te cuesta un domicilio.
                </p>

                <Button size="xl" fullWidth className="mb-4 bg-blue-500 hover:bg-blue-400 text-white border-0 shadow-lg shadow-blue-900/50" onClick={() => {
                trackAddToCart();
                window.open('https://mapaclaro.com/cart/52341272543521:1', '_blank');
              }} data-id="element-160">
                  Descargar Ahora
                </Button>

                <p className="text-xs text-slate-500" data-id="element-161">
                  Acceso inmediato • Pago seguro
                </p>
              </div>
            </div>
          </div>

          {/* Guarantee */}
          <div className="mt-8 bg-white p-5 rounded-2xl border border-slate-200 flex flex-col md:flex-row items-center gap-4 text-center md:text-left" data-id="element-162">
            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-163">
              <Shield className="w-7 h-7 text-green-600" data-id="element-164" />
            </div>
            <div data-id="element-165">
              <h4 className="font-bold text-slate-900 text-lg mb-1" data-id="element-166">
                Garantía de 7 días
              </h4>
              <p className="text-slate-600 text-sm" data-id="element-167">
                Si en 7 días no tienes tu Mapa de Deudas lleno y tu PMV
                definido, escríbeme y te devuelvo el dinero. (Condición: debes
                haber completado las plantillas).
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}